import React, { Fragment } from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import ColorPicker from '../../../Components/ColorPicker';
import LabelColorSlider from '../../../Components/LabelColorSlider';

const toggleStyle = { color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' };

const ValueColorSettings = ({
  edit,
  setEdit,
  t,
  selectedDatastream,
  getDsMinMax,
  themeColorKey,
  themeColorValue,
  valueColorWidgetTypes,
}) => {
  if (!valueColorWidgetTypes.includes(edit.type)) {
    return null;
  }

  return (
    <Fragment>
      <div className="form-item">
        <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
          {t.settingsLabels?.changeColorBasedOnValue || "Change color based on value"}
        </label>
        {edit.props.changeColorBasedOnValue ? (
          <ToggleOn
            style={toggleStyle}
            onClick={() => setEdit({ ...edit, props: { ...edit.props, changeColorBasedOnValue: false } })} />
        ) : (
          <ToggleOff
            style={toggleStyle}
            onClick={() => setEdit({ ...edit, props: { ...edit.props, changeColorBasedOnValue: true } })} />
        )}
      </div>

      {edit.props.changeColorBasedOnValue ? (
        <Fragment>
          <div className="form-item">
            <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
              {t.settingsLabels?.colorGrading || "Smooth Gradient Transition"}
            </label>
            {edit.props.colorGrading ? (
              <ToggleOn
                style={toggleStyle}
                onClick={() => setEdit({ ...edit, props: { ...edit.props, colorGrading: false } })} />
            ) : (
              <ToggleOff
                style={toggleStyle}
                onClick={() => setEdit({ ...edit, props: { ...edit.props, colorGrading: true } })} />
            )}
          </div>

          <LabelColorSlider
            minValue={getDsMinMax(selectedDatastream).min ?? edit.props.min}
            maxValue={getDsMinMax(selectedDatastream).max ?? edit.props.max}
            stops={themeColorValue(edit.props, 'colors', [])}
            colorGrading={Boolean(edit.props.colorGrading)}
            setStops={(updated) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('colors')]: updated }
            }))}
          />
        </Fragment>
      ) : (
        <div className="form-item">
          <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.color || "Fixed Color"}
          </label>
          <ColorPicker
            id="fixed-color"
            color={themeColorValue(edit.props, 'color')}
            setColor={(c) => setEdit(prev => ({
              ...prev,
              props: { ...prev.props, [themeColorKey('color')]: c }
            }))}
          />
        </div>
      )}
    </Fragment>
  );
};

export default ValueColorSettings;
